<template>
  <div class="bg-container">
    <v-container fluid fill-height :style="{ maxWidth: '1200px' }">
      <v-layout flex align-center>
        <v-flex flex xs12 sm6 md6 offset-sm3 offset-md3>
          <v-card class="no-shadow no-background">
            <v-card-title primary-title>
              <h1 class="headline">Register</h1>
            </v-card-title>
            <v-card-text>
              <p class="head-description">
                Already have an account?
                <router-link to="/login">Log in</router-link>
              </p>
            </v-card-text>
            <v-card-text>
              <p v-if="form.invite">
                You are using a partner invite which grants you additional
                account fuel.
              </p>
              <p v-if="form.ref_code_referrer">
                You are using a friend referral link, which grants you
                additional account fuel after your first deposit.
              </p>

              <v-form
                ref="form"
                v-model="valid"
                @submit.prevent="login"
                @keydown="form.onKeydown($event)"
              >
                <v-layout>
                  <v-flex md6 sm12 class="mr-4">
                    <v-text-field
                      v-model="form.email"
                      label="E-Mail"
                      placeholder="E-Mail"
                      single-line
                      required
                      autofocus
                      class="placeholer-color"
                      :rules="[v => !!v || 'Item required']"
                      type="email"
                    ></v-text-field>
                    <has-error :form="form" field="email"></has-error>
                  </v-flex>
                  <v-flex md6 sm12>
                    <v-text-field
                      v-model="form.name"
                      label="Username"
                      placeholder="Username"
                      single-line
                      required
                      class="placeholer-color"
                      :rules="[v => !!v || 'Item required']"
                    ></v-text-field>
                    <has-error :form="form" field="username"></has-error>
                  </v-flex>
                </v-layout>
                <v-text-field
                  v-model="form.password"
                  label="Password"
                  :type="type"
                  placeholder="Password"
                  single-line
                  required
                  class="placeholer-color"
                  :rules="[v => !!v || 'Item required']"
                >
                  <template v-slot:append>
                    <img
                      width="24"
                      height="24"
                      :src="password_icon"
                      alt=""
                      @click="togglePassword"
                    />
                  </template>
                </v-text-field>
                <has-error :form="form" field="password"></has-error>

                <v-text-field
                  v-model="form.password_confirmation"
                  label="Re-enter password"
                  :type="type"
                  placeholder="Re-enter password"
                  single-line
                  required
                  class="placeholer-color"
                  :rules="[v => !!v || 'Item required']"
                >
                  <template v-slot:append>
                    <img
                      width="24"
                      height="24"
                      :src="password_icon"
                      alt=""
                      @click="togglePassword"
                    />
                  </template>
                </v-text-field>
                <has-error
                  :form="form"
                  field="password_confirmation"
                ></has-error>

                <div v-if="!form.ref_code_referrer">
                  <v-text-field
                    v-model="form.invite"
                    label="Invite code (if any)"
                    placeholder="Invite code (if any)"
                    single-line
                    required
                    class="placeholer-color"
                  ></v-text-field>
                  <has-error :form="form" field="invite"></has-error>
                </div>
              </v-form>

              <v-layout class="mt-38">
                <v-flex>
                  <p class="terms">
                    By clicking “Register”, you agree to the
                    <a href="/terms">Terms of Use</a> and
                    <a href="/privacy">Privacy Policy</a>.
                  </p>
                </v-flex>
              </v-layout>

              <v-layout class="mt-2">
                <v-flex class="text-xs-left">
                  <v-btn
                    :disabled="!valid"
                    :loading="form.busy"
                    class="btn-register"
                    color="primary"
                    style="color: #ffffff !important;"
                    right
                    @click="register()"
                    >{{ $t("Register") }}</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Form from "vform";
import swal from "sweetalert2";

export default {
  metaInfo() {
    return { title: this.$t("register") };
  },

  data: () => ({
    type: "password",
    password_icon: "/img/eye-icon.svg",
    valid: true,
    form: new Form({
      invite: null,
      ref_code_referrer: null,
      name: "",
      email: "",
      password: "",
      password_confirmation: ""
    })
  }),

  computed: {
    githubAuth: () => window.config.githubAuth
  },
  mounted: async function() {
    this.form.invite = this.$route.query.invite;
    this.form.ref_code_referrer = this.$route.query.referral;
  },
  methods: {
    async register() {
      // Register the user.
      if (this.$refs.form.validate()) {
        try {
          const { data } = await this.form.post("/api/v1/register");

          await swal({
            showCloseButton: true,
            imageUrl: "/img/popup_img_login_success.jpg",
            imageHeight: 80,
            imageWidth: 80,
            imageAlt: "Registration succeeded",
            title: "Registration succeeded",
            html: "Please check your mail for a verification link",
            customClass: "swal-login-register",
            confirmButtonText: "Okay"
          });

          // Redirect home.
          this.$router.push({ name: "welcome" });
        } catch (error) {
          swal({
            title: "Error registering",
            text: error.response.data.message,
            showConfirmButton: false,
            showCloseButton: true,
            customClass: "swal-type-error",
            imageUrl: "/img/popup_img_error.png",
            imageHeight: 80,
            imageWidth: 80
          });
        }
      }
    },
    togglePassword() {
      this.type = this.type === "password" ? "text" : "password";
      this.password_icon =
        this.type === "password"
          ? "/img/eye-icon.svg"
          : "/img/eye-open-icon.svg";
    }
  }
};
</script>

<style scoped>
.bg-container {
  background: url("/img/background-center.png") center top no-repeat,
  url("/img/background-full.jpg") repeat;
  height: 100%;
}
.no-shadow {
  box-shadow: none !important;
}
.no-background {
  background: transparent;
}
>>> .v-btn {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #ffffff !important;
  background: linear-gradient(180deg, #468aff 0%, #0051dd 100%);
  border-radius: 30px;
  width: 196px;
  height: 44px;
  box-shadow: none !important;
}
.terms {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 140%;
  color: #103a84;
}
.terms a {
  margin-left: 0px;
}

.headline {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 40px !important;
  line-height: 48px !important;
  letter-spacing: 0.02em !important;
  background: -webkit-linear-gradient(#468aff, #0051dd);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.head-description {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 140%;
  color: #103a84;
}
.head-description a {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 140%;
  text-decoration-line: underline;
  background: -webkit-linear-gradient(#468aff, #0051dd);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-left: 9px;
  text-decoration-color: #0051dd;
}

.placeholer-color >>> input::placeholder {
  color: #b8d2ff !important;
  opacity: 1;
}
>>> .v-input__slot::before {
  border-color: #b8d2ff !important;
}
.mt-38 {
  margin-top: 38px !important;
}
.v-messages__message {
  color: #ed4242;
}
@media (max-width: 1440px) {
  .bg-container {
    background: url("/img/background-center.png") center top no-repeat,
    url("/img/background-full-1440.jpg") repeat;
    height: 100%;
  }
}
@media (max-width: 768px) {
  .bg-container {
    background: #ffffff url("/img/bg-tablet-left.jpg") left top no-repeat;
    height: 100%;
  }
}

@media (max-width: 600px) {
  .bg-container {
    background: #ffffff;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// resources/js/pages/auth/register.vue